module.exports = __webpack_public_path__ + "static/fbeauty__step-1-24b94452ff7267965d9cbbd50a9d9bb8.jpg";